<div class="hotspot-medium-device">
  <mds-button-toggle
    [checkedButton]="'Hostspots'"
    [multiple]="false"
    [name]="'App Data'"
    [options]="toggleData"
    class="switch-button"
    (change)="onSwitchView()">
  </mds-button-toggle>
  @if (isToggleChart) {
    <div class="hotspot-chart">
      <ng-container [ngTemplateOutlet]="hotspots"></ng-container>
    </div>
  }
  @if (!isToggleChart) {
    <div class="hotspot-chart">
      <ng-container [ngTemplateOutlet]="emissions"></ng-container>
    </div>
  }
</div>
<div class="hotspot-rest-device">
  <ng-container [ngTemplateOutlet]="hotspots"></ng-container>
  <ng-container [ngTemplateOutlet]="emissions"></ng-container>
</div>
<ng-template #hotspots>
  <app-dual-charts-card
    class="first"
    [title]="'Top hotspots'"
    [description]="'Top contributors to the scores'"
    [loading]="loading1"
    [isEmpty]="!hasHotspots"
    [emptyChart]="{title: 'No hotspots available at the moment', description: 'Once there’s data on the table on the left a graph will display here with the top 5 impacts + top 5 spend classes.'}"
    [firstChartOptions]="impactChartOptions"
    [secondChartOptions]="spendChartOptions"
  ></app-dual-charts-card>
</ng-template>
<ng-template  #emissions>
  <app-dual-charts-card
    class="second"
    [title]="'Total emissions'"
    [description]="'By scope & category'"
    [isEmpty]="!hasScopes"
    [loading]="loading2"
    [emptyChart]="{title: 'Emissions chart unavailable', description: 'Once there’s data on the table on the left a graph will display here'}"
    [firstChartOptions]="scopesChartOptions"
    [secondChartOptions]="categoriesChartOptions"
  ></app-dual-charts-card>
</ng-template>


